import * as Yup from 'yup';

export function validationSchema() {
  return Yup.object({
    email: Yup.string()
      .email('Please enter a vaild email address')
      .required('Email is required'),
    password: Yup.string()
      .required('No password provided.')
  });
}

